import { render } from "./MenuLogo.vue?vue&type=template&id=79bdb5ca&scoped=true"
import script from "./MenuLogo.vue?vue&type=script&lang=js"
export * from "./MenuLogo.vue?vue&type=script&lang=js"

import "./MenuLogo.vue?vue&type=style&index=0&id=79bdb5ca&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\intelligent_farm\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bdb5ca"]])

export default __exports__